// extracted by mini-css-extract-plugin
export default {"navlink":"settings_navlink__5gTD3","active":"settings_active__KScfG"};